// Which models the app uses (SERVER.md §7). Accounts whose plan has `features.chooseModels` (admins, the plus plan)
// pick them in Settings like the phones; everyone else uses the server's fixed `models` from `/v1/me`, and the
// Text model / Speech model pages are replaced by MODEL_CHOICE_LINE. The proxy refuses other models with
// 403 model_not_allowed. A missing flag counts as true (older servers).
import { account } from "./api/account";
import { currentVoice, settings, type DecisionsBackend, type NarrationVoice, type VoiceProvider } from "./settings";

const str = (v: unknown): string | null => (typeof v === "string" && v ? v : null);

export const canChooseModels = () => account.canChooseModels;

export function textModel(): string {
  return (account.canChooseModels ? null : str(account.serverModels.text)) ?? settings.model.trim();
}

export function askModel(): string {
  return (account.canChooseModels ? null : str(account.serverModels.ask)) ?? settings.askModel.trim();
}

export function decisionsBackend(): DecisionsBackend {
  const d = account.canChooseModels ? null : str(account.serverModels.decisions);
  return d === "auto" || d === "openai" || d === "jev" ? d : settings.decisionsBackend;
}

export function narrationVoice(): NarrationVoice {
  if (account.canChooseModels) return currentVoice();
  const m = account.serverModels;
  const provider = str(m.speechProvider);
  const model = str(m.speechModel);
  if (!model || !(provider === "gemini" || provider === "openrouter" || provider === "openai")) return currentVoice();
  return { provider: provider as VoiceProvider, model, voice: str(m.speechVoice) ?? "" };
}

/** The proxy's 403 for a model this account may not use. */
export function modelNotAllowedMessage(model?: string): string {
  return `${model ? `“${model}”` : "That model"} isn't available on your plan; Depth uses the server's models for this account.`;
}

/** Shown where the Text model / Speech model rows would be when the account can't choose. */
export const MODEL_CHOICE_LINE = "Model choice comes with a higher plan.";
